export const state = () => ({
  homeURL: null
})

export const mutations = {
  setHomeURL(state, url) {
    state.homeURL = url
  }
}
